import { Box, InputAdornment, Button, Paper, TextField } from "@material-ui/core";

import Autocomplete from '@material-ui/lab/Autocomplete';

import { makeStyles } from '@material-ui/core/styles';
import ProviderListComponent from '../components/ProviderListComponent';
import ActivityListComponent from '../components/ActivityListComponent';
import BranchListComponent from '../components/BranchListComponent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import { Link as RouterLink } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import { useEffect, useState } from "react";
import { useConfirm } from 'material-ui-confirm';
import { deleteProviderAndUser, fetchProvidersList, fetchActivityList, fetchBranchList, toggleProviderVisibility } from '../api/admin';

const useStyles = makeStyles((theme) => ({
    topHeading: {
        display: 'flex',
        margin: theme.spacing(0.5, 0, 4, 0),
        alignItems: 'center',
    },
    search: {
        width: '100%',
        margin: theme.spacing(1, 8),
    }
}));
export default function ProviderListPage({ onProviderListRemove,  onClick, user }) {
    const classes = useStyles();
    const confirm = useConfirm();
    
    const [queryID, setQueryID] = useState('');
    const [queryName, setQueryName] = useState('');

    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(25);

    const [branchFilter, setBranchFilter] = useState(false);
    const [paginatorOptions, setPaginatorOptions] = useState({totalDocs:0, hasNextPage: false, hasPrevPage: false})

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const [state, setStateValue] = useState('Activity');
    const [isWithImage, setIsWithImage] = useState(false);

    // async function fatchList(page, itemsPerPage, query ,branchFilter, token) { 
    //     if(state === "Provider"){
    //         return await fetchProvidersList(page, itemsPerPage, query, branchFilter, token);
    //     } else if(state === "Branch") {
    //         return await fetchBranchList(page, itemsPerPage, query, branchFilter, token);

    //     } else{
    //         return await fetchActivityList(page, itemsPerPage, query, branchFilter, token);
    //     }
    // }

    useEffect(() => {
        let active = true;
        (async () => {
            setLoading(true);
            let {docs, ...paginatorData} = state === "Provider"? await fetchProvidersList(page, itemsPerPage, queryID, queryName,  branchFilter, user.token)
            : state === "Branch" ? await fetchBranchList(page, itemsPerPage, queryID, queryName, user.token) : 
            await fetchActivityList(page, itemsPerPage, queryID, queryName, isWithImage, user.token);
            if (!active) return;
            setRows(docs);
            setPaginatorOptions(paginatorData);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [page, itemsPerPage, queryID, queryName, user, branchFilter, state, isWithImage])


    const handleProviderDelete = async (id) => {
        try {
            await confirm({ description: 'This action is permanent!' })
            // setLoading(true);
            await deleteProviderAndUser(id, user.token)
            onProviderListRemove(id);
        } catch {
            console.log('delete cancelled');
        } finally {
            // setLoading(false);
        }
    }

    const handleProviderVisibilityToggle = async (row) => {
        try {
            await toggleProviderVisibility(row._id, user.token)

            const updatedRows = [...rows];
            const index = updatedRows.findIndex((p) => p._id === row._id);
            console.log(index);
            updatedRows[index].visibility = !updatedRows[index].visibility;
            setRows(updatedRows);
        } catch (e) {
            console.log(e);
        } finally {
            // setLoading(false);
        }
    }

    return (
        <Paper style={{ padding: '1em' }} variant="outlined">
            <Box className={classes.topHeading}>
                {/* <Typography variant="h4" style={{ flex: 1 }}>
                    Providers
                </Typography> */}
                <div className={classes.search} style={{ flex: 2, display:'flex', flexDirection: 'row', gap: '40px',}}>

                    <Autocomplete fullWidth
                        options={['Provider', 'Branch', 'Activity']}
                        autoHighlight
                        disableClearable
                        size="small"
                        value={state}
                        onChange={(e, val) => {setPage(1);setStateValue(val)}}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                // label="Emirate"
                                variant="outlined"
                            />
                        )}
                    />
                    <TextField fullWidth
                        id="search"
                        label="Search"
                        variant="outlined"
                        size="small"
                        placeholder="Filter by ID"
                        style={{marginRight:16}}
                        onChange={(e) => {setPage(1);setQueryID(e.target.value.toLocaleLowerCase())}}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start"> 
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField fullWidth
                        id="search"
                        label="Search"
                        variant="outlined"
                        size="small"
                        placeholder="Filter by Name"
                        style={{marginRight:16}}
                        onChange={(e) => {setPage(1);setQueryName(e.target.value.toLocaleLowerCase())}}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start"> 
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                { state === "Provider" ? 
                <div style={{ flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Button variant="contained"
                        color="secondary"
                        component={RouterLink}
                        startIcon={<AddOutlinedIcon />}
                        disableElevation
                        to="/create-provider">
                        Add Provider
                    </Button> 
                </div> : "" }
                { state === "Activity" ?
                <div style={{ flex: 1, display: 'inline-flex', alignItems: 'start' }}>
                    <FormControlLabel
                        style={{minWidth:150}}
                        size="small"
                        control={<Checkbox size="small" checked={isWithImage} onChange={(e) => setIsWithImage(e.target.checked)} name="isWithImage" />}
                        label="Filter with Images"
                    />
                </div> : "" }
                { state === "Branch" ? 
                <div style={{ flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'flex-end' }}>

                </div>: ""}
            </Box>

            {(() => {              
         if(state === "Provider") {
            return <ProviderListComponent
                rows={rows}
                loading={loading}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={(i) => {setPage(1);setItemsPerPage(i)}}
                page={page}
                onPageChange={setPage}
                paginatorOptions={paginatorOptions}

                handleProviderView={onClick}
                handleProviderVisibilityToggle={handleProviderVisibilityToggle}
                handleProviderDelete={handleProviderDelete}
                user={user} />
         } else if(state === "Branch") {
            return <BranchListComponent
                rows={rows}
                loading={loading}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={(i) => {setPage(1);setItemsPerPage(i)}}
                page={page}
                onPageChange={setPage}
                paginatorOptions={paginatorOptions}

                handleProviderView={onClick}
                handleProviderVisibilityToggle={handleProviderVisibilityToggle}
                handleProviderDelete={handleProviderDelete}
                user={user} />
            } else {
            return    <ActivityListComponent
                rows={rows}
                loading={loading}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={(i) => {setPage(1);setItemsPerPage(i)}}
                page={page}
                onPageChange={setPage}
                paginatorOptions={paginatorOptions}

                handleProviderView={onClick}
                handleProviderVisibilityToggle={handleProviderVisibilityToggle}
                handleProviderDelete={handleProviderDelete}
                user={user} />
            }
        })()}
        </Paper>
    )
}
